// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"RateCard_iconWrapper__cOm1P","container":"RateCard_container__cK2jF","infoBlock":"RateCard_infoBlock__Q885N"};